module.exports = __webpack_public_path__ + "img/10-2.d642ed80.jpg";